import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8C7E4E'
    }
  },

  tag: {
    backgroundColor: 'white',
    color: '#8C7E4E'
  },
});

export { theme };
